import request from 'services/axios'

export interface ISupportBotTurn {
    role: 'user' | 'assistant'
    content: string
}

export interface ISupportBotAnswer {
    answer: string
    /** True when the backend routed this to a human before asking the model. */
    escalated: boolean
    tools_used: string[]
    /**
     * How the answer was actually produced — the server owns the vocabulary.
     *
     * Optional because a canned failure reply comes back as a perfectly normal
     * 200, so every deploy of this client can meet a backend that does not send
     * these yet. Read them defensively; never assume `outcome` is a success.
     */
    outcome?: string
    escalation_reason?: string
}

/**
 * پشتیبان هوشمند — POST a question, get an answer.
 *
 * The server decides everything that matters: which fund data the answer may
 * draw on (always scoped to the JWT, never to anything sent from here) and
 * whether the message should skip the model and go straight to a human. The
 * `history` is a convenience for follow-up questions; the server replays only
 * plain user/assistant turns from it.
 */
export const askSupportBot = async (payload: {
    question: string
    history?: ISupportBotTurn[]
}) => {
    const { data }: { data: ISupportBotAnswer } = await request.post(
        '/api/v1/support-bot/ask/',
        {
            question: payload.question,
            history: payload.history ?? [],
        }
    )
    return data
}
